export default "__VITE_ASSET__CqgsJd3r__"